import type { MarkNotificationAsFailed200SourceSourceUser } from './markNotificationAsFailed200SourceSourceUser';

export type MarkNotificationAsFailed200Source = {
  sourceUser?: MarkNotificationAsFailed200SourceSourceUser;
  /** @nullable */
  sourceUserId?: number | null;
};
